var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _text, _path20, _text2, _path21, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem38(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st3{fill:#fff}.st11{fill:#369;fill-opacity:.502}.st12{font-family:&apos;ArialMT&apos;}.st13{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M535.6 141.2c-.5-.4-1.3-.5-2.2-.5h-.5c-2.9.7-4.4 2.6-4.4 5.6.4 1.9 1.4 3.2 3.1 4-1.6 4.2-4.1 8-7.4 11.3-6.1 6-13.4 9-22 9.1h-8v2.2h8.2c15.3-.9 25.8-8.3 31.4-22.1 1.1-3.1 1.7-6.3 1.8-9.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 30.9982,
    cy: 402.7488,
    r: 16.45,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 440.7538 873.6602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#575757"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M497.1 171c17.4-1.6 26.9-11.2 28.5-28.7-1.6-17.4-11.1-26.9-28.5-28.5-17.4 1.6-27 11.1-28.7 28.5 1.7 17.6 11.3 27.1 28.7 28.7z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 30.9982,
    cy: 402.7488,
    r: 3.4,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 440.8446 873.5695)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7686,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M501.8 142.4c-.3-2.8-1.9-4.4-4.7-4.7-3 .3-4.5 1.9-4.7 4.7.2 2.8 1.8 4.4 4.7 4.7 2.9-.3 4.4-1.9 4.7-4.7z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478 204.4v20.3H340.6V47.9h305.2v193.7H229.6v-91.1H165v1.8h62.8v91.1h419.8V46H338.8v180.5h141.1v-22.1H478z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 85.5v-1.8h-233v67.4h1.8V85.5h231.2zM518.5 241.8v-37.6h-1.8v37.6h1.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M588.1 226.5V85.4H402.5V225h1.8V87.2h181.9v137.4H518v1.8h70.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M535.7 209.7v-37.6h-77.3v37.6h77.3m-1.4-36.1v34.7h-74.4v-34.7h74.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M510.5 86.2c-.8-8.8-5.6-13.6-14.3-14.3-8.8.8-13.7 5.6-14.5 14.3.8 8.8 5.7 13.7 14.5 14.5 8.7-.8 13.5-5.6 14.3-14.5z",
    className: "st3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M496.3 71.2C487 72 482 77.1 481 86.3c.9 9.3 6 14.3 15.3 15.3 9.2-.9 14.2-6 15.1-15.3-.9-9.2-5.9-14.2-15.1-15.1m9.6 5.5c2.6 2.6 3.9 5.8 4 9.6-.1 3.9-1.4 7.1-4 9.8-2.5 2.5-5.7 3.8-9.6 4-3.9-.2-7.2-1.5-9.8-4-2.5-2.7-3.8-5.9-4-9.8.2-3.8 1.5-7 4-9.6 2.6-2.6 5.9-3.9 9.8-4 3.8.1 7 1.4 9.6 4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 30.9982,
    cy: 402.7489,
    r: 4.1,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 439.9367 817.5602)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.3 86.3c-.4-4.2-2.8-6.5-7.1-6.9-4.4.4-6.7 2.7-7.1 6.9.4 4.4 2.7 6.7 7.1 7.1 4.3-.4 6.6-2.8 7.1-7.1z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M496.2 79c-4.6.4-7.1 2.8-7.4 7.3.4 4.6 2.8 7.1 7.4 7.4 4.5-.4 7-2.8 7.4-7.4-.4-4.5-2.9-6.9-7.4-7.3m-6.7 7.3c.4-4 2.6-6.2 6.7-6.5 3.9.4 6.2 2.5 6.7 6.5-.5 4.2-2.8 6.4-6.7 6.7-4.1-.3-6.4-2.6-6.7-6.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M661.2 145.2c-.8-8.8-5.7-13.6-14.5-14.3-8.8.8-13.6 5.6-14.3 14.3.8 8.8 5.6 13.7 14.3 14.5 8.8-.8 13.6-5.7 14.5-14.5z",
    className: "st3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M646.8 130.3c-9.2.8-14.2 5.9-15.1 15.1.8 9.3 5.9 14.3 15.1 15.3 9.3-.9 14.3-6 15.3-15.3-1-9.2-6.1-14.3-15.3-15.1m9.6 5.4c2.7 2.5 4.1 5.7 4.2 9.6-.1 3.9-1.5 7.1-4.2 9.6-2.5 2.7-5.7 4.1-9.6 4.2-3.9-.1-7.1-1.5-9.6-4.2-2.6-2.5-3.9-5.7-4-9.6.1-3.9 1.4-7.1 4-9.6 2.5-2.6 5.7-3.9 9.6-4 3.9.1 7.1 1.4 9.6 4z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 30.9982,
    cy: 402.7489,
    r: 4,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 590.3679 876.5651)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M653.7 145.4c-.4-4.3-2.8-6.7-7.1-7.1-4.2.5-6.6 2.8-7.1 7.1.5 4.2 2.8 6.6 7.1 7.1 4.3-.5 6.7-2.8 7.1-7.1z",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M646.6 138c-4.5.5-7 3-7.4 7.4.5 4.5 3 7 7.4 7.4 4.5-.4 7-2.9 7.4-7.4-.3-4.4-2.8-6.9-7.4-7.4m-6.7 7.4c.4-4.1 2.7-6.3 6.7-6.7 4.1.4 6.3 2.7 6.7 6.7-.4 4.1-2.7 6.3-6.7 6.7-4-.4-6.3-2.6-6.7-6.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.4 110.8c-.8-8.8-5.6-13.7-14.3-14.5-8.8.8-13.6 5.7-14.3 14.5.8 8.8 5.6 13.6 14.3 14.3 8.8-.8 13.6-5.6 14.3-14.3z",
    className: "st3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 95.4c-9.2.9-14.2 6-15.1 15.3.8 9.2 5.9 14.2 15.1 15.1 9.2-.8 14.2-5.9 15.1-15.1-.9-9.3-5.9-14.3-15.1-15.3m9.6 5.7c2.6 2.5 3.9 5.7 4 9.6-.1 3.9-1.4 7.1-4 9.6-2.5 2.6-5.7 3.9-9.6 4-3.9-.1-7.1-1.4-9.6-4-2.6-2.5-3.9-5.7-4-9.6.1-3.9 1.4-7.1 4-9.6 2.5-2.7 5.7-4.1 9.6-4.2 4 .1 7.2 1.5 9.6 4.2z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 30.9982,
    cy: 402.7489,
    r: 4,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 50.8313 841.9791)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.2 110.8c-.4-4.2-2.8-6.6-7.1-7.1-4.2.5-6.6 2.8-7.1 7.1.5 4.3 2.8 6.7 7.1 7.1 4.3-.5 6.7-2.8 7.1-7.1z",
    style: {
      fill: "url(#SVGID_5_)"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.1 103.3c-4.5.4-7 2.8-7.4 7.4.5 4.5 3 7 7.4 7.4 4.5-.5 7-3 7.4-7.4-.4-4.5-2.9-7-7.4-7.4m-6.7 7.5c.4-4.1 2.7-6.3 6.7-6.7 4.1.4 6.3 2.7 6.7 6.7-.4 4.1-2.7 6.3-6.7 6.7-4.1-.4-6.3-2.7-6.7-6.7zM166.6 150.9l1.3-1.3c-9-8.5-19.2-12.8-30.7-12.7-11.6-.1-21.7 4.2-30.5 12.7l1.3 1.3c8.5-8.1 18.2-12.2 29.2-12.2 11.1.1 20.9 4.1 29.4 12.2zM107.4 239.2c9.8-.2 15.2-1.3 16.2-3.3H91.1c.9 2 6.4 3.1 16.3 3.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    x1: 30.9982,
    x2: 51.9982,
    y1: 320.1989,
    y2: 320.1989,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 31.7664 777.2552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505050"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.2 154.9H88.1V237h38.1v-82.1z",
    style: {
      fill: "url(#SVGID_6_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    x1: 33.7982,
    x2: 49.4982,
    y1: 323.0489,
    y2: 323.0489,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 31.7664 777.2552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 209.6v-37.8H93.1v37.8h28.5z",
    style: {
      fill: "url(#SVGID_7_)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.2 154.9c-.2-1.6-1.1-2.5-2.7-2.7H90.8c-1.6.2-2.5 1.1-2.7 2.7h38.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.7 152.9c-.2-1.6-1.1-2.5-2.7-2.7h-1.8c-1.6.2-2.5 1.1-2.7 2.7h7.2z",
    className: "st3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.4 152.9c-.2-2.1-1.4-3.2-3.4-3.4h-1.8c-2.1.2-3.2 1.4-3.4 3.4h1.5c.1-1.2.8-1.9 2-2h1.8c1.2.1 1.9.8 2 2h1.3zM165.4 239.2c9.8-.2 15.2-1.3 16.2-3.3h-32.5c.9 2 6.4 3.1 16.3 3.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    x1: 62.8982,
    x2: 83.8982,
    y1: 320.1989,
    y2: 320.1989,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 31.7664 777.2552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#505050"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505050"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M184.1 154.9H146V237h38.1v-82.1z",
    style: {
      fill: "url(#SVGID_8_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    x1: 65.6982,
    x2: 81.3982,
    y1: 323.0489,
    y2: 323.0489,
    gradientTransform: "matrix(1.8157 0 0 -1.8155 31.7664 777.2552)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5255,
    style: {
      stopColor: "#f9f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 171.9v37.8h28.5v-37.8h-28.5z",
    style: {
      fill: "url(#SVGID_9_)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M184 154.9c-.2-1.6-1.1-2.5-2.7-2.7h-32.7c-1.6.2-2.5 1.1-2.7 2.7H184z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M168.7 152.9c-.2-1.6-1.1-2.5-2.7-2.7h-1.8c-1.6.2-2.5 1.1-2.7 2.7h7.2z",
    className: "st3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M169.4 152.9c-.2-2.1-1.4-3.2-3.4-3.4h-1.8c-2.1.2-3.2 1.4-3.4 3.4h1.5c.1-1.2.8-1.9 2-2h1.8c1.2.1 1.9.8 2 2h1.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 83.4c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st11"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st3 st12 st13",
    transform: "matrix(.9981 0 0 1 61.9673 96.9678)"
  }, "\n    2\n  ")), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M469.2 57.1c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st11"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st3 st12 st13",
    transform: "matrix(.9981 0 0 1 456.7168 70.668)"
  }, "\n    1\n  ")), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M692.9 135.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st11"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st3 st12 st13",
    transform: "matrix(.9981 0 0 1 680.417 149.5181)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem38);
export default __webpack_public_path__ + "static/media/item38.23d52220262689753460579ed95ce707.svg";
export { ForwardRef as ReactComponent };